import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";

const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  var token = userProfileSession && userProfileSession["token"];
  const [loading, setLoading] = useState(userProfileSession ? false : true);
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );

  useEffect(() => {
    // Add a small delay to ensure localStorage is available during hot reloads
    const timer = setTimeout(() => {
      const userProfileSession = getLoggedinUser();
      var token = userProfileSession && userProfileSession["token"];
      setUserProfile(userProfileSession ? userProfileSession : null);
      setLoading(false); // Always set loading to false after checking
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return { userProfile, loading, token };
};

export { useProfile };
